import { StatusCodes } from 'http-status-codes';
import { axiosInstance } from './axiosInstance';

export const getAdvance = async (applicationId) => {

  let response;

  try {

    response = await axiosInstance.get(`/app/${applicationId}/advance`);

    if (response.status !== StatusCodes.OK || !response.data) {

      throw new Error('GetAdvanceDetailsError');
    }

  } catch (error) {

    const errorResponse = error.response || {};

    if (errorResponse.status === StatusCodes.NOT_FOUND) {
      response = { data: null };
    } else {
      throw error;
    }
  }

  return response.data;
};

export const getAdvanceRepayment = async (applicationId) => {

  let response;

  try {

    response = await axiosInstance.get(`/app/${applicationId}/advance-repayment`);

    if (response.status !== StatusCodes.OK || !response.data) {

      throw new Error('GetAdvanceRepaymentDetailsError');
    }

  } catch (error) {

    const errorResponse = error.response || {};

    if (errorResponse.status === StatusCodes.NOT_FOUND) {
      response = { data: null };
    } else {
      throw error;
    }
  }

  return response.data;
};
